// Flash message toast, top-right. The toast markup is only rendered by the
// server when a notice/alert is present, and gets freshly re-rendered (or
// omitted) on every Turbolinks visit, so it's initialized on "turbolinks:load"
// (which fires on the very first page load too) rather than via the
// event-delegation pattern used elsewhere for user-triggered interactions.

var AUTO_DISMISS_MS = 4000

document.addEventListener('turbolinks:load', function () {
  var toast = document.getElementById('pj-toast')
  if (!toast) return

  var timer = setTimeout(dismiss, AUTO_DISMISS_MS)

  function dismiss() {
    clearTimeout(timer)
    toast.classList.add('pj-toast-leaving')
  }

  var closeBtn = toast.querySelector('.pj-toast-close')
  if (closeBtn) closeBtn.addEventListener('click', dismiss)

  // Next frame, so the transition from the initial (offscreen) state runs.
  requestAnimationFrame(function () {
    toast.classList.add('pj-toast-visible')
  })
})
